<template>
  <div>
    <!-- 打印SKU -->
    <el-dialog
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="打印SKU二维码"
      width="50%"
    >
      <el-form>
        <el-row v-for="(item, index) in skuForm" :key="index">
          <p>
            <el-col :span="24"
              ><span>{{ item.skushow }}</span>
              <span>，打印</span>
              <el-input-number
                v-model="item.boxCount"
                auto-complete="off"
                placeholder="请输入打印数量"
                :min="1"
                :max="100"
                onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
              ></el-input-number>
              <span>&nbsp;&nbsp;&nbsp;&nbsp; 张</span></el-col
            >
          </p>
        </el-row>
        <el-row>
          <p>
            <el-col :span="24"
              ><span style="color: red">一次打印请勿超过100张哦</span>
            </el-col>
          </p>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click="onSubmitsku" :loading="editLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
    <TwTable
      :searchData="searchData"
      :buttonList="buttonList"
      :tableData="tableData"
      :tableConfig="tableConfig"
      @resetBtn="resetBtn"
      :pageConfig="pageConfig"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:status>
        <el-select multiple v-model="filters.status" placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in statuslist"
            :label="item.text"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:department>
        <el-select multiple v-model="filters.department" placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in departmentList"
            :label="item.department"
            :value="item.department"
            :key="item.department"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:realName>
        <el-select multiple v-model="filters.realName" filterable placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
      <template slot-scope="scope" slot="baiYiNumber">
        <div
          v-if="scope.row.baiYiNumber != null && scope.row.baiYiNumber != ''"
        >
          <div
            v-for="(item, index) in scope.row.baiYiNumber.split(',')"
            :key="index"
          >
         {{ item }}
          </div>
        </div>
      </template>
    </TwTable>
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 9, businessCode: currentRow.twDeliveryNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
  </div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";

import {
  getTWDeliveryInfoDepartment,
  getTWDeliveryInfoQueryList,
  getTWDeliveryInfoQueryOut,
  editTWDeliveryInfoStatus,
  printDeliveryInfoSku,
  getOperatorInfo,
} from "../../api/api";
import axios from "axios";
import LogDialog from "../../components/TwTable/components/logDialog";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { thereAre } from "util/util";
export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showResetButton: true,
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {   //操作栏配置
          align: "center",
          
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "sku",
            label: "SKU",
            align: "center",
            sortable: true,
            minWidth: "200",
          },
          {
            label: "单号信息",
            align: "center",
            sortable: true,
            minWidth: "220",
            formatter: function (val, row) {
              return (
                "<span>采购单号: " +
                (row.relationNumber||"") +
                "</span><br /><span>提货单号: " +
                (row.trackNumber||"") +
                "</span><br /> <span>入库单号: " +
                (row.twDeliveryNo||"") +
                "</span>"
              );
            },
          },
          {
            prop: "department",
            label: "部门",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "estimatedDate",
            label: "预计到仓日期",
            align: "center",
            sortable: true,
             minWidth: "120",
          },
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
           
          },
          {
            label: "总数量",
            formatter: function (val, row) {
              return (
                "<span>总数量:" +
                row.deliveryQty +
                "</span><br /><span>收货数量: " +
                row.receiveQty +
                "</span><br /> <span>上架数量:" +
                row.putStockQty +
                "</span><br />"
              );
            },
          },
          {
            prop: "statusshow",
            label: "状态",
            align: "center",
            sortable: true,
          },
          {
            label: "操作人",
            formatter: function (val, row) {
              return (
                "<span>收货:" +
                row.overSignForUser +
                "</span><br /><span>上架: " +
                row.overPutStockUser 
              );
            },
          },
          {
            label: "时间信息",
            minWidth: "220",
            formatter: function (val, row) {
              return (
                "<span>创建时间:" +
                row.createTime +
                "</span><br /><span>完成收货:" +
                (row.overSignForTime || "") +
                "</span><br /><span>完成上架:" +
                (row.overPutStockTime || "") +
                "</span><br />"
              );
            },
          },
          {
            prop: "baiYiNumber",
            label: "佰易签收单",
            align: "center",
            slot: true,
            minWidth: "150",
          },
        ],
      },
      searchData: {
        //搜索列配置
        search: [
          {
            type: "input",
            key: "sku",
            label: "SKU",
            placeholder: "多个SKU用逗号分开查询",
            clearable: true,
          },
          {
            type: "select",
            key: "status",
            prop: "status",
            label: "状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.statuslist,
          },
          
           {
            type: "input",
            key: "relationNumber",
            label: "采购单号",
            placeholder: "多个采购单号用逗号分开查询",
            clearable: true,
          },
          {
            type: "input",
            key: "trackNumber",
            label: "提货单号",
            placeholder: "多个提货单号用逗号分开查询",
            clearable: true,
          },
         
        ],
        ///高级搜索配置
        moreSearch: [
          {
            type: "input",
            key: "tWDeliveryNo",
            label: "入库单号",
            placeholder: "多个入库单号用逗号分开查询",
            clearable: true,
          },
          {
            type: "input",
            key: "baiYiNumber",
            label: "佰易签收单号",
            placeholder: "多个佰易签收单号用逗号分开查询",
            clearable: true,
          },
          {
            type: "select",
            key: "department",
            prop: "department",
            label: "部门",
            multiple: true,
            slot: true,
            placeholder: "请选择部门",
            option: this.departmentList,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "预计到仓日期",
          },
          {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },
        ],
      },
      buttonList: [],
      skuForm: [],
      editFormVisible: false,
      editLoading: false,
      departmentList: [],
      userList:[],

      validation: true,
      statuslist: [
        {
          value: 20,
          text: "在途",
        },
        {
          value: 30,
          text: "部分收货",
        },
        {
          value: 40,
          text: "完全收货",
        },
        {
          value: 50,
          text: "完结",
        },
      ],
    };
  },
  methods: {
    resetBtn() {
      this.filters = {};
    },
    baiYisingle(baiyi) {
      let html = "";
      if (baiyi != null && baiyi != "") {
        let single = baiyi.split(",");
        single.forEach((item) => {
          html += " <div>" + item + " </div>";
        });
      }

      return html;
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
         this.newfilters =JSON.parse(JSON.stringify(this.filters)) 
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    //弹出打印sku框
    handlePint() {
      let row = this.selectRows.rows;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择要打印的数据！",
          type: "error",
        });
        return;
      }
      this.skuForm = [];
      row.forEach((item) => {
        let skurow = {
          sku: item.sku,
          skushow: item.sku + "（" + item.productNameCN + ")",
          boxCount: item.boxCount,
          productNameCN: item.productNameCN,
        };
        this.skuForm.push(skurow);
      });
      this.editFormVisible = true;
    },
    //打印
    onSubmitsku() {
      let row = this.skuForm;
      row.forEach((item) => {
        if (
          item.boxCount == 0 ||
          item.boxCount == "" ||
          item.boxCount == null
        ) {
          this.$message({
            message: item.skushow + "打印数量错误，请修改",
            type: "error",
          });
          return;
        }
      });
      let para = Object.assign([], row);
      this.editLoading = true;

      const loading = this.$loading({
        lock: true,
        text: "打印中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      printDeliveryInfoSku(para).then((res) => {
        this.editLoading = false;
        loading.close();
        if (res.data.success) {
          window.open(res.data.response, "_blank");
          this.editFormVisible = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //点击完结按钮
    handleEnable() {
      let row = this.selectRows.rows;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择要完结的一行数据！",
          type: "error",
        });
        return;
      }

      if (row.length == 1) {
        if (row[0].status == 10 || row[0].status == 40 || row[0].status == 50) {
          this.validation = false;
          this.$message({
            message: "当前数据为" + row[0].statusshow + "状态，无需完结！",
            type: "error",
          });
          return;
        }
      }
      var tWDeliveryNo = "";
      row.forEach((item) => {
        tWDeliveryNo += item.twDeliveryNo + ",";
        if (item.status == 10 || item.status == 40 || item.status == 50) {
          this.validation = false;
          this.$message({
            message: "请选择在途，部分收货的数据完结！",
            type: "error",
          });

          return false;
        }
      });

      let para = Object.assign([], row);

      console.log(para);
      if (this.validation) {
        this.$confirm(
          "确定完结" +
            tWDeliveryNo.slice(0, tWDeliveryNo.length - 1) +
            "单据吗?",
          "提示",
          {}
        )
          .then(() => {
            editTWDeliveryInfoStatus(para).then((res) => {
              if (res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.initTable();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //查询
    initTable() {
      const {
        sku,
        tWDeliveryNo,
        relationNumber,
        trackNumber,
        department,
        realName,
        baiYiNumber,
        status,
        tdate,
      } =  this.newfilters;

      let pata = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        sku,
        tWDeliveryNo,
        relationNumber,
        trackNumber,
        department: thereAre(department),
        realName:thereAre(realName),
        baiYiNumber,
        status: thereAre(status),
      };
      if (tdate != null && tdate != "null") {
        pata.startdate = tdate[0];
        pata.enddate = tdate[1];
      }
      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getTWDeliveryInfoQueryList(pata).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;
        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
      let tsDeliveryInfoIDs = "";
      row.forEach((item) => {
        tsDeliveryInfoIDs += item.twDeliveryInfoID + ",";
      });

      const {
        sku,
        tWDeliveryNo,
        relationNumber,
        trackNumber,
        department,
        baiYiNumber,
        status,
        tdate,
      } =  this.newfilters;

      let pata = {
        page: 1,
        pageSize: 60001,
        sku,
        tWDeliveryNo,
        relationNumber,
        trackNumber,
        department: thereAre(department),
        baiYiNumber,
        status: thereAre(status),
        tsDeliveryInfoIDs: thereAre(tsDeliveryInfoIDs),
      };
      if (tdate != null && tdate != "null") {
        pata.startdate = tdate[0];
        pata.enddate = tdate[1];
      }

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: getTWDeliveryInfoQueryOut,
        method: "post",
        data: pata,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
      getTWDeliveryInfoDepartment({ orgId: user.organizationId }).then(
        (res) => {
          this.departmentList = res.data.response;
        }
      );

      getOperatorInfo().then(
        (res) => {
          this.userList = res.data.response;
        }
      );
    },
  },
  mounted() {
    //查询按钮权限
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    console.info(routers);
    this.buttonList = getButtonList(this.$route.path, routers);

    this.getBasicdatalist();
  },
};
</script>